import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { StaticValueService } from './static-value.service';

@Injectable()
export class StaticDataResolver implements Resolve<any> {
    constructor(private service: StaticValueService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.service.getStaticValues().then((data) => {
        }).catch((error) => {
            console.log('error', error);
        });
    }
}
